import React from 'react';
import { Platform } from 'react-native';

const ICONS: Record<string, string> = {
  // From components.jsx
  "check":    "M5 12l5 5L20 7",
  "x":        "M6 6l12 12M18 6 6 18",
  "plus":     "M12 5v14M5 12h14",
  "minus":    "M5 12h14",
  "chev-l":   "m15 6-6 6 6 6",
  "chev-r":   "m9 6 6 6-6 6",
  "chev-d":   "m6 9 6 6 6-6",
  "chev-u":   "m6 15 6-6 6 6",
  "arrow-r":  "M5 12h14m-6-6 6 6-6 6",
  "search":   "M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM21 21l-4.35-4.35",
  "edit":     "M12 20h9M16.5 3.5a2.1 2.1 0 1 1 3 3L7 19l-4 1 1-4z",
  "trash":    "M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
  "settings": "M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM19 12c0-.4 0-.8-.1-1.2l2-1.6-2-3.4-2.4.9c-.6-.5-1.3-.9-2-1.2L14 3h-4l-.5 2.5c-.7.3-1.4.7-2 1.2l-2.4-.9-2 3.4 2 1.6c-.1.4-.1.8-.1 1.2s0 .8.1 1.2l-2 1.6 2 3.4 2.4-.9c.6.5 1.3.9 2 1.2L10 21h4l.5-2.5c.7-.3 1.4-.7 2-1.2l2.4.9 2-3.4-2-1.6c.1-.4.1-.8.1-1.2z",
  "user":     "M4 21c0-4 4-7 8-7s8 3 8 7M12 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8z",
  "users":    "M2 21c0-4 3-6 7-6s7 2 7 6M9 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8zM17 14c3 0 6 2 6 6M17 11a3 3 0 1 0 0-6",
  "calendar": "M3 5h18v16H3zM3 9h18M8 3v4M16 3v4",
  "clock":    "M12 7v5l3 2M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18z",
  "bell":     "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10 21a2 2 0 0 0 4 0",
  "mail":     "M3 6h18v12H3zM3 6l9 7 9-7",
  "phone":    "M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.1-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .3 2 .7 3a2 2 0 0 1-.5 2L8 10a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2-.5c1 .4 2 .6 3 .7a2 2 0 0 1 1.7 2z",
  "lock":     "M5 11h14v10H5zM8 11V8a4 4 0 1 1 8 0v3",
  "external": "M14 4h6v6M20 4 10 14M20 14v6H4V4h6",
  "filter":   "M3 5h18l-7 8v7l-4-2v-5z",
  "download": "M12 3v12m0 0 4-4m-4 4-4-4M4 17v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3",
  "upload":   "M12 21V9m0 0 4 4m-4-4-4 4M4 7V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3",
  "info":     "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zM12 8v.01M12 11v5",
  "warn":     "M12 3 2 21h20L12 3zM12 10v4M12 18v.01",
  "more":     "__dots__",
  "menu":     "M4 6h16M4 12h16M4 18h16",
  "home":     "M3 11l9-8 9 8M5 10v11h14V10",
  "star":     "M12 3l3 6.5 7 1-5 5 1.2 7L12 19l-6.2 3.5L7 15l-5-5 7-1z",
  "heart":    "M20.8 5.6a5.5 5.5 0 0 0-7.8 0L12 6.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 22l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.6z",
  "eye":      "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z",
  "copy":     "M9 3h11v14H9zM4 7v14h13",
  // From util.jsx
  "box":          "M21 8 12 3 3 8m18 0-9 5-9-5m18 0v8l-9 5-9-5V8m9 5v8",
  "grid":         "M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z",
  "layers":       "M12 3 3 8l9 5 9-5-9-5zM3 13l9 5 9-5M3 16.5l9 5 9-5",
  "tag":          "M3 3h7l11 11-7 7L3 10V3zM7 7h.01",
  "tags":         "M9 3H4v5l8 8 5-5-8-8zM7 7h.01M14 6l6 6-4 4",
  "folder":       "M3 6a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6z",
  "globe":        "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM3 12h18M12 3a14 14 0 0 1 0 18 14 14 0 0 1 0-18z",
  "key":          "M15 7a4 4 0 1 1-3.9 5H8v3H5v3H2v-4l6.1-6.1A4 4 0 0 1 15 7zM16 8h.01",
  "zap":          "M13 2 4 14h7l-2 8 9-12h-7l2-8z",
  "sliders":      "M4 6h10M18 6h2M4 12h2M10 12h10M4 18h12M20 18h0M14 4v4M6 10v4M16 16v4",
  "map-pin":      "M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11zM12 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
  "image":        "M3 5h18v14H3zM3 16l5-5 4 4 3-3 6 6M8.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
  "sparkles":     "M12 3l1.6 4.6L18 9l-4.4 1.4L12 15l-1.6-4.6L6 9l4.4-1.4L12 3zM19 14l.8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8L19 14z",
  "database":     "M12 3c4.4 0 8 1.3 8 3s-3.6 3-8 3-8-1.3-8-3 3.6-3 8-3zM4 6v12c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3",
  "list":         "M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01",
  "archive":      "M3 4h18v4H3zM5 8v12h14V8M9 12h6",
  "package":      "M16.5 9.4 7.5 4.2M3 7l9 5 9-5-9-5-9 5zm0 0v10l9 5 9-5V7M12 12v10",
  "rupee":        "M6 4h12M6 8h12M16 4c0 4-3 5-7 5h-1l7 8",
  "dollar":       "M12 2v20M17 6a4 4 0 0 0-4-3H10a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-3a4 4 0 0 1-4-3",
  "store":        "M3 9 5 4h14l2 5M4 9h16v11H4zM4 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0",
  "link":         "M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1",
  "play":         "M6 4l14 8-14 8V4z",
  "pause":        "M7 4h4v16H7zM13 4h4v16h-4z",
  "refresh":      "M21 12a9 9 0 1 1-2.6-6.3M21 4v5h-5",
  "dup":          "M9 9h11v11H9zM5 15V4h11",
  "logout":       "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9",
  "grip":         "M9 5h.01M15 5h.01M9 12h.01M15 12h.01M9 19h.01M15 19h.01",
  "shield":       "M12 3 4 6v6c0 4.4 3.2 7.6 8 9 4.8-1.4 8-4.6 8-9V6l-8-3zM9 12l2 2 4-4",
  "flag":         "M4 21V4h11l-1.5 4H20v8h-7l1.5-4H4",
  "calendar2":    "M3 5h18v16H3zM3 9h18M8 3v4M16 3v4M8 13h2M14 13h2M8 17h2",
  "chart":        "M4 20V10M10 20V4M16 20v-7M22 20H2",
  "bolt-off":     "M13 2 4 14h4M11 22l2-8h4",
  "check-circle": "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zM8.5 12.5l2.5 2.5 4.5-5",
  "alert-circle": "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zM12 8v5M12 16v.01",
  "save":         "M5 3h12l4 4v14H3V3h2zm2 0v6h8V3M7 21v-7h10v7",
  "send":         "M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z",
  "translate":    "M4 5h8M9 3v2c0 4-2.5 7-6 8M6 9c0 3 2.5 5 6 6M13 20l4-9 4 9M14.5 17h5",
  "wand":         "M15 4V2M15 10V8M11 6H9M21 6h-2M18.5 3.5 17 5M18.5 8.5 17 7M5 21l11-11",
  "moon":         "M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z",
  "sun":          "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4",
  "dots-grid":    "M5 5h.01M12 5h.01M19 5h.01M5 12h.01M12 12h.01M19 12h.01M5 19h.01M12 19h.01M19 19h.01",
  "history":      "M3 12a9 9 0 1 0 3-6.7L3 8m0-5v5h5M12 7v5l4 2",
  "import":       "M12 3v12m0 0 4-4m-4 4-4-4M4 17v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3",
  "webhook":      "M9 7a3 3 0 1 1 4 2.8L10.5 14M15 12a3 3 0 1 1-1 5.8H9M9 17a3 3 0 1 1-2.5-4.4L9 8",
  "message":      "M21 12a8 8 0 0 1-11.3 7.3L3 21l1.7-6.7A8 8 0 1 1 21 12z",
};

export type IconName =
  | 'check' | 'x' | 'plus' | 'minus' | 'chev-l' | 'chev-r' | 'chev-d' | 'chev-u'
  | 'arrow-r' | 'search' | 'edit' | 'trash' | 'settings' | 'user' | 'users'
  | 'calendar' | 'clock' | 'bell' | 'mail' | 'phone' | 'lock' | 'external'
  | 'filter' | 'download' | 'upload' | 'info' | 'warn' | 'more' | 'menu'
  | 'home' | 'star' | 'heart' | 'eye' | 'copy'
  | 'box' | 'grid' | 'layers' | 'tag' | 'tags' | 'folder' | 'globe' | 'key'
  | 'zap' | 'sliders' | 'map-pin' | 'image' | 'sparkles' | 'database' | 'list'
  | 'archive' | 'package' | 'rupee' | 'dollar' | 'store' | 'link' | 'play'
  | 'pause' | 'refresh' | 'dup' | 'logout' | 'grip' | 'shield' | 'flag'
  | 'calendar2' | 'chart' | 'bolt-off' | 'check-circle' | 'alert-circle' | 'save'
  | 'send' | 'translate' | 'wand' | 'moon' | 'sun' | 'dots-grid' | 'history'
  | 'import' | 'webhook' | 'message';

export interface IconProps {
  name: string;
  size?: number;
  color?: string;
  style?: any;
}

const Icon: React.FC<IconProps> = ({ name, size = 16, color = 'currentColor', style }) => {
  const d = ICONS[name];

  // On web use inline SVG (avoids react-native-svg dep entirely)
  if (Platform.OS === 'web') {
    // Three-dot menu icon — rendered as filled circles for crisp display
    if (d === '__dots__') {
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          aria-hidden="true"
          style={{ display: 'inline-block', flexShrink: 0, ...style }}
        >
          <circle cx="5" cy="12" r="1.5" fill={color} />
          <circle cx="12" cy="12" r="1.5" fill={color} />
          <circle cx="19" cy="12" r="1.5" fill={color} />
        </svg>
      );
    }
    if (!d) {
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          aria-hidden="true"
          style={{ display: 'inline-block', flexShrink: 0, ...style }}
        >
          <circle cx="12" cy="12" r="2" fill={color} />
        </svg>
      );
    }
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        style={{ display: 'inline-block', flexShrink: 0, ...style }}
      >
        <path d={d} />
      </svg>
    );
  }

  // Native: use react-native-svg
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { default: Svg, Path, Circle } = require('react-native-svg');

  // Three-dot menu icon
  if (d === '__dots__') {
    return (
      <Svg width={size} height={size} viewBox="0 0 24 24" style={style}>
        <Circle cx="5" cy="12" r="1.5" fill={color} />
        <Circle cx="12" cy="12" r="1.5" fill={color} />
        <Circle cx="19" cy="12" r="1.5" fill={color} />
      </Svg>
    );
  }

  if (!d) {
    return (
      <Svg width={size} height={size} viewBox="0 0 24 24" style={style}>
        <Circle cx="12" cy="12" r="2" fill={color} />
      </Svg>
    );
  }

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
    >
      <Path d={d} />
    </Svg>
  );
};

export default Icon;
